<script setup>
import AppLink from './AppLink.vue';
import AppCard from './AppCard.vue';

const props = defineProps({
  header: String,
  body: String,
  to: String,
})
</script>
<template>
  <!-- old block height h-[30vh] -->
  <AppLink v-bind="props"
    >
    <AppCard 
      :header="props.header"
      :body="props.body">
    
      <slot />
    </AppCard>
  </AppLink>
</template>